import sourcingManagerService from "../service/sourcingManagerService"
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import {  SOURCING_MANAGER_DETAILS, SOURCING_MANAGER_LIST, } from "../types";

export const getSourcingManagerList = (item) => async (dispatch) => {
  try {
    const res = await sourcingManagerService.getSourcingManagerList(item);
    if (res.data.status === 200) {
      dispatch({
        type: SOURCING_MANAGER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: SOURCING_MANAGER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getSourcingManagerDetails = (item) => async (dispatch) => {
  try {
    const res = await sourcingManagerService.getSourcingManagerDetails(item);
    if (res.data.status === 200) {
      dispatch({
        type: SOURCING_MANAGER_DETAILS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: SOURCING_MANAGER_DETAILS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};